import { useState } from "react";
import { Input, Switch } from "antd";

function Degree({
  setBtnHandler,
  setCoordinateArray,
  setSearchState,
  searchState,
}) {
  const [long, setLong] = useState({
    long1: 0,
    long2: 0,
    long3: 0,
  });
  const [lat, setLat] = useState({
    lat1: 0,
    lat2: 0,
    lat3: 0,
  });

  return (
    <div>
      {" "}
      <div
        className="flex flex-row items-center justify-between inner-box-hover w-[60vw] max-w-[500px] relative   
max-lg:flex-col max-lg:gap-1 "
      >
        <section className="flex flex-col pr-4 max-lg:px-4 items-center justify-center gap-1  p-2">
          <div className="flex flex-row-reverse gap-2 max-lg:px-2">
            <p className="text-[#404848] w-6">عرض</p>
            <Input
              autoComplete="nope"
              // defaultValue={defaultValue ? defaultValue : null}
              optionFilterProp="label"
              className="lg:w-16 !h-5 input-neo max-lg:w-full !bg-none  !border-none hover:!bg-[#edf2f8] focus:!bg-[#edf2f8] focus:border-none rounded-xl focus:!shadow-none"
              onChange={(e) => {
                // setCoordinateArray([
                //   Number(e.target.value.split(",")[0]),
                //   Number(e.target.value.split(",")[1]),
                // ]);
                // setBtnHandler(e.target.value);
                setLat((prev) => ({ ...prev, lat1: e.target.value / 1 }));
                setCoordinateArray([
                  lat.lat1 + lat.lat2 + lat.lat3,
                  long.long1 + long.long2 + long.long3,
                ]);
              }}
            />
            <p className="text-[#404848] w-1 h-3 text-2xl">°</p>

            <Input
              autoComplete="nope"
              // suffixIcon={<SearchOutlined />}
              showSearch
              // defaultValue={defaultValue ? defaultValue : null}
              optionFilterProp="label"
              className="lg:w-16 !h-5 input-neo max-lg:w-full !bg-none !border-none hover:!bg-[#edf2f8] focus:!bg-[#edf2f8] focus:border-none rounded-xl focus:!shadow-none"
              onChange={(e) => {
                // setCoordinateArray([
                //   Number(e.target.value.split(",")[0]),
                //   Number(e.target.value.split(",")[1]),
                // ]);
                // setBtnHandler(e.target.value);

                setLat((prev) => ({ ...prev, lat2: e.target.value / 60 }));
                setCoordinateArray([
                  lat.lat1 + lat.lat2 + lat.lat3,
                  long.long1 + long.long2 + long.long3,
                ]);
              }}
            />
            <p className="text-[#404848] w-1 h-3 text-2xl">'</p>

            <Input
              autoComplete="nope"
              // suffixIcon={<SearchOutlined />}
              showSearch
              className="lg:w-16 !h-5 input-neo max-lg:w-full !bg-none !border-none hover:!bg-[#edf2f8] focus:!bg-[#edf2f8] focus:border-none rounded-xl focus:!shadow-none"
              onChange={(e) => {
                // setCoordinateArray([
                //   Number(e.target.value.split(",")[0]),
                //   Number(e.target.value.split(",")[1]),
                // ]);
                // setBtnHandler(e.target.value);

                setLat((prev) => ({ ...prev, lat3: e.target.value / 3600 }));
                setCoordinateArray([
                  lat.lat1 + lat.lat2 + lat.lat3,
                  long.long1 + long.long2 + long.long3,
                ]);
              }}
            />
            <p className="text-[#404848] w-1 h-3 text-2xl">"</p>
          </div>
          <div className="flex flex-row-reverse gap-2 max-lg:px-2">
            <p className="text-[#404848] w-6">طول</p>
            <Input
              accept="number"
              type="number"
              autoComplete="nope"
              // defaultValue={defaultValue ? defaultValue : null}
              className="lg:w-16 !h-5 input-neo max-lg:w-full !bg-none  !border-none hover:!bg-[#edf2f8] focus:!bg-[#edf2f8] focus:border-none rounded-xl focus:!shadow-none"
              onChange={(e) => {
                // setCoordinateArray([
                //   Number(e.target.value.split(",")[0]),
                //   Number(e.target.value.split(",")[1]),
                // ]);
                // setBtnHandler(e.target.value);
                setLong((prev) => ({ ...prev, long1: e.target.value / 1 }));
                setCoordinateArray([
                  lat.lat1 + lat.lat2 + lat.lat3,
                  long.long1 + long.long2 + long.long3,
                ]);
              }}
            />
            <p className="text-[#404848] w-1 h-3 text-2xl">°</p>

            <Input
              accept="number"
              type="number"
              autoComplete="nope"
              // suffixIcon={<SearchOutlined />}
              showSearch
              // defaultValue={defaultValue ? defaultValue : null}
              optionFilterProp="label"
              className="lg:w-16 !h-5 input-neo max-lg:w-full !bg-none !border-none hover:!bg-[#edf2f8] focus:!bg-[#edf2f8] focus:border-none rounded-xl focus:!shadow-none"
              onChange={(e) => {
                // setCoordinateArray([
                //   Number(e.target.value.split(",")[0]),
                //   Number(e.target.value.split(",")[1]),
                // ]);
                // setBtnHandler(e.target.value);
                setLong((prev) => ({ ...prev, long2: e.target.value / 60 }));
                setCoordinateArray([
                  lat.lat1 + lat.lat2 + lat.lat3,
                  long.long1 + long.long2 + long.long3,
                ]);
              }}
            />
            <p className="text-[#404848] w-1 h-3 text-2xl">'</p>

            <Input
              accept="number"
              type="number"
              autoComplete="nope"
              showSearch
              optionFilterProp="label"
              className="lg:w-16 !h-5 input-neo max-lg:w-full !bg-none !border-none hover:!bg-[#edf2f8] focus:!bg-[#edf2f8] focus:border-none rounded-xl focus:!shadow-none"
              onChange={(e) => {
                // setCoordinateArray([
                //   Number(e.target.value.split(",")[0]),
                //   Number(e.target.value.split(",")[1]),
                // ]);
                setBtnHandler("");
                setLong((prev) => ({ ...prev, long3: e.target.value / 3600 }));
                setCoordinateArray([
                  lat.lat1 + lat.lat2 + lat.lat3,
                  long.long1 + long.long2 + long.long3,
                ]);
              }}
            />
            <p className="text-[#404848] w-1 h-3 text-2xl">"</p>
          </div>
        </section>

        <div className="flex flex-row items-center gap-2 lg:ml-1 max-lg:bg-[#00000062] max-lg:p-1 max-lg:rounded-2xl ">
          <p className="text-sm whitespace-nowrap max-lg:text-white  max-lg:text-xs">
            جستجو پیشرفته:
          </p>
          <Switch
            className="bg-agroyar hover:!bg-agroyar"
            onChange={(e) => {
              setSearchState(e);
            }}
            checked={searchState}
            checkedChildren="غیرفعال"
            unCheckedChildren="فعال"
          />
        </div>
      </div>
    </div>
  );
}

export default Degree;
